import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { get } from 'lodash';
import React from 'react';
import { Button } from 'src/components/Antd';
import { OriCheckbox as Checkbox } from 'src/components/Antd/Checkbox/Checkbox';
// import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import DroppableTable from 'src/components/DroppableTable/EditDraggableTable';
import { TableInput } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableTip';
import { CheckoutErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/ErrorContext';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import { EnumTablePosition } from 'src/types/common/common';
import { EnumFieldType as Types, nameDict } from 'src/types/common/customerDb';
import css from './css.module.less';
import Modal from './Modal';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export { Types };
// export enum Types {
//   FirstName = 'FirstName',
//   LastName = 'LastName',
//   FullName = 'FullName',
//   Email = 'Email',
//   MobileNumber = 'MobileNumber',
//   TelephoneNumber = 'TelephoneNumber',
//   Title = 'Title',
//   CompanyName = 'CompanyName',
// }
export const dict = {
  [Types.FirstName]: { displayName: nameDict[Types.FirstName] },
  [Types.LastName]: { displayName: nameDict[Types.LastName] },
  [Types.FullName]: { displayName: nameDict[Types.FullName] },
  [Types.Email]: { displayName: nameDict[Types.Email] },
  [Types.AreaCodeMobileNumber]: {
    displayName: nameDict[Types.AreaCodeMobileNumber],
  },
  //  [Types.TelephoneNumber]: { displayName: 'Telephone Number' },
  [Types.Title]: { displayName: nameDict[Types.Title] },
  [Types.MobileNumber]: { displayName: nameDict[Types.MobileNumber] },
  [Types.CompanyName]: { displayName: nameDict[Types.CompanyName] },
  [Types.TelephoneNumber]: { displayName: nameDict[Types.TelephoneNumber] },
};

const hasOTC = [Types.MobileNumber, Types.Email];

const fields = [
  { name: Types.FirstName },
  { name: Types.LastName },
  { name: Types.FullName },
  { name: Types.Email },
  { name: Types.MobileNumber },
  { name: Types.TelephoneNumber },
  // { name: Types.AreaCodeMobileNumber },
  { name: Types.Title },
  { name: Types.CompanyName },
];

const RecipientInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { reInformationEmptyError, setReInformationEmptyError } =
    React.useContext(CheckoutErrorContext);

  const {
    title,
    subtitle,
    data,
    onChange,
    setHasModified,
    isRecipient,
    disableEdit,
  } = props;

  const [visible, setVisible] = React.useState(false);

  const handleHasModified = () => {
    setHasModified(true);
  };

  const handleOnFieldSort = (e) => {
    handleHasModified();
    if (onChange) {
      onChange(e);
    }
  };

  const handleOnClose = () => {
    setVisible(false);
  };

  const handleOnAdd = () => {
    setVisible(true);
  };

  const availableFields = React.useMemo(() => {
    const hasSeperatedNames = data.find((i) => {
      const name = get(i, 'field.name');
      return name === Types.FirstName || name === Types.LastName;
    });

    const hasFullName = data.find((i) => {
      const name = get(i, 'field.name');
      return name === Types.FullName;
    });

    const _fields = fields.reduce((pre, now) => {
      const name = get(now, 'name');

      if (name === Types.FullName && hasSeperatedNames) {
        return [...pre, { ...now, disabled: true }];
      }
      if (
        (name === Types.FirstName || name === Types.LastName) &&
        hasFullName
      ) {
        return [...pre, { ...now, disabled: true }];
      }
      return [...pre, now];
    }, []);
    return _fields;
  }, [fields, data]);

  const handleOnChange = (data) => {
    setReInformationEmptyError(false);
    handleHasModified();
    handleOnClose();
    onChange(data);
  };

  const handleOnDelete = (index) => {
    handleHasModified();
    const _data = [...(data || [])];
    _data.splice(index, 1);
    if (onChange) {
      onChange(_data);
    }
  };

  const handleOnRequiredChange = (index, checked) => {
    handleHasModified();
    const _data = [...(data || [])];
    (_data[index] || {}).required = checked;
    if (onChange) {
      onChange(_data);
    }
  };

  const handleOnOTCChange = (index, checked) => {
    handleHasModified();
    const _data = [...(data || [])];
    (_data[index] || {}).otpRequired = checked;
    if (onChange) {
      onChange(_data);
    }
  };

  const handleOnRegexChange = (value, index) => {
    handleHasModified();
    const _data = [...(data || [])];
    (_data[index] || {}).regex = value;
    if (onChange) {
      onChange(_data);
    }
  };
  return (
    <SectionWrapper title={title} subtitle={subtitle}>
      {visible && (
        <Modal
          availableFields={availableFields}
          visible={visible}
          data={data}
          onOk={handleOnChange}
          onCancel={handleOnClose}
        />
      )}
      <Tip>{getI18n('salesChannelCheckout.index.recipientInfoTips')}</Tip>
      <DroppableTable
        error={
          reInformationEmptyError
            ? getI18n('salesChannelCheckout.index.reInformationEmptyError')
            : ''
        }
        //rowSelection={row}
        hideAllDragHandlers={disableEdit}
        pagination={false}
        rowKey={'name'}
        dataSource={data || []}
        columns={col(
          handleOnDelete,
          handleOnRequiredChange,
          handleOnOTCChange,
          handleOnRegexChange,
          disableEdit,
          { getI18n },
        )}
        id='SalesChannelCheckoutRecipientInfoTable'
        onTableChange={handleOnFieldSort}

        // rowDeleteFunc={deleteProduct}
      />
      <Button
        onClick={handleOnAdd}
        type='primary'
        className={css.addNew}
        disabled={disableEdit}>
        {isRecipient
          ? getI18n('salesChannelCheckout.index.selectRecipientInformation')
          : getI18n('salesChannelCheckout.index.selectReceiverInformation')}
      </Button>
    </SectionWrapper>
  );
};
export default RecipientInfo;
const col = (
  onDelete,
  onRequiredChange,
  onOtcChange,
  onRegexChange,
  disableEdit,
  { getI18n },
) => {
  return [
    {
      title: getI18n('salesChannelCheckout.index.recipientInformation'),
      key: 'InfoField',
      default: true,
      childGenerate: (url, record) => {
        const { name: n } = record;
        const name = get(dict, `${n}.displayName`);
        return (
          <NoWrapContainer>
            <GlobalTooltip title={name}>{name}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      minWidth: 224,
    },
    {
      title: getI18n('salesChannelCheckout.index.setasRequiredField'),
      key: 'type',
      default: true,
      childGenerate: (url, record, index) => {
        const { required, otpRequired, name } = record;
        return (
          <div className={css.checkContainer}>
            <div className={css.reqCheckbox}>
              <Checkbox
                checked={required}
                onChange={(e) => {
                  const checked = e.target.checked;
                  onRequiredChange(index, checked);
                }}
                disabled={disableEdit}>
                {required
                  ? getI18n('general.required')
                  : getI18n('general.optional')}
              </Checkbox>
            </div>
            {hasOTC.includes(name) && (
              <div className={css.otpRequired}>
                <Checkbox
                  checked={otpRequired}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    onOtcChange(index, checked);
                  }}
                  disabled={disableEdit}>
                  {getI18n(
                    'salesChannelCheckout.index.oTPVerificationrequired',
                  )}
                </Checkbox>
              </div>
            )}
          </div>
        );

        // return (
        //   <NoWrapContainer>
        //     <GlobalTooltip title={typeName}>{typeName}</GlobalTooltip>
        //   </NoWrapContainer>
        // );
      },
      width: 384,
    },
    {
      title: () => {
        return (
          <div>
            <EditIcon />
            {getI18n(
              'salesChannelCheckout.index.advancedValidationExpressionregex',
            )}
          </div>
        );
      },
      key: 'regex',
      dataIndex: 'regex',
      width: 320,
      default: true,
      childGenerate: (text, record, index) => {
        const excluded = ['TelephoneNumber', 'MobileNumber', 'Email'];
        const { name = '' } = record;
        return excluded.includes(name) ? (
          <div>{text}</div>
        ) : (
          <TableInput
            label={text}
            value={text}
            placeholder='/ [ \x00-\xFF ] /'
            // itemProps={{ placeholder: '/ [ \x00-' + '\xFF ] /' }}
            onChange={(value) => {
              if (onRegexChange) {
                onRegexChange(value, index);
              }
            }}
            disabled={disableEdit}
          />
        );
      },
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          key: 'Actions',
          default: true,
          childGenerate: (url, record, index) => {
            return (
              <div className={css.tableLastContainer}>
                <div
                  className={css.delete}
                  onClick={() => {
                    onDelete(index);
                  }}>
                  {getI18n('general.delete')}
                </div>
              </div>
            );
          },
          width: 128,
        },
  ];
};
